import { useEffect, useState } from "react";
import { Col, DatePicker, Form, Input, Select } from "antd";
import { isArrayAndHasValue } from "../../../utils/functions";
import { GET_USERS_ENDPOINT, IOU_COST_TAKEN_BY_USERS_ENDPOINT } from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";

const IOUCostFilter = () => {
  const [usersList, setUsersList] = useState([]);
  const { Option } = Select;
  // base on path name render dynamic filter fields
  const pathName = window.location.pathname;
  const isIOUCost = pathName.includes("iou-cost");

  useEffect(() => {
    const fetchUsers = async () => {
      const endpoint = isIOUCost
        ? IOU_COST_TAKEN_BY_USERS_ENDPOINT
        : GET_USERS_ENDPOINT;
      const res = await getData(endpoint);
      if (res) {
        setUsersList(
          isIOUCost
            ? res?.data?.data || []
            : res?.data?.data?.data || [],
        );
      }
    };

    fetchUsers();
  }, [isIOUCost]);

  return (
    <>
      <Col span={6}>
        <Form.Item name="iou_number" label="IOU Number">
          <Input placeholder="Search by IOU Number" />
        </Form.Item>
      </Col>

      {
        isIOUCost && (
          <>
          <Col span={6}>
        <Form.Item name="from_date" label="From Date">
          <DatePicker
            style={{ width: "100%" }}
            format="YYYY-MM-DD"
            placeholder="Select From Date"
            size="small"
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item name="to_date" label="To Date">
          <DatePicker
            style={{ width: "100%" }}
            format="YYYY-MM-DD"
            placeholder="Select To Date"
            size="small"
          />
        </Form.Item>
      </Col>
          </>
        )
      }

      

      <Col span={6}>
        <Form.Item name="taken_by" label="Taken By">
          <Select
            showSearch
            allowClear
            placeholder="Select User"
            optionFilterProp="children"
            size="small"
          >
            {isArrayAndHasValue(usersList) &&
              usersList.map((user) => (
                <Option value={user.id} key={user.id}>
                  {user.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>

      {/* <Col span={6}>
        <Form.Item name="status" label="Status">
          <Select
            placeholder="Select Status"
            allowClear
            options={[
              { value: "requested", label: "Requested" },
              { value: "approved", label: "Approved" },
              { value: "rejected", label: "Rejected" },
              { value: "by_department", label: "By Department" },
              { value: "by_director", label: "By Director" },
            ]}
          />
        </Form.Item>
      </Col> */}
    </>
  );
};

export default IOUCostFilter;
